import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import theme from '../../muiTheme';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

export class DespliceDialog extends Component
{
  
render() {

    return (

      <Dialog
       titleStyle={styles.errorDialogTitle}
       title="De-splice"
       open={this.props.open}>
              <DialogContent>
              <div style={{padding: "5px 5px 5px 5px"}}>
              <Typography variant="h3" component="h3">
              <b>Warning</b>
              </Typography>
              <p>This will delete the existing FODR record, and a new FODR will be generated for each of the source records which are currently part of this record.</p>

              <p>This operation <u>cannot be undone</u>, and will result in the <b>loss of all edits made to this FODR.</b></p>

              <p>Are you sure you want to continue?</p>
              </div>

              </DialogContent>
       <DialogActions>
        <Button onClick={this.props.onRequestClose} color="primary">
          No, Cancel
        </Button>
          <Button onClick={this.props.despliceRecordConfirmed} color="primary">
            Yes, De-splice and reset to original sources
        </Button>
      </DialogActions>
     </Dialog>
    )
  }
}

export default DespliceDialog;
